import {Data} from "./data";
import {CheckDocuments, Documents} from "./documents";

class PaymentService {

  Data(type) {
    return Data(type)
  }

  Documents(docs) { return Documents(docs) }

  ListDocuments() { return CheckDocuments() }

}

export default new PaymentService();
